import { registerCheckoutBlock } from '@woocommerce/blocks-checkout';
import { GiftCardBlock } from './block.js';
import metadata from './block.json';
const settings = wc.wcSettings.getSetting('woosquare-giftcard_data');

if( settings?.enabled ) {
	metadata.parent = [ "woocommerce/checkout-order-summary-block" ];

	registerCheckoutBlock( {
		metadata,
		component: GiftCardBlock,
	} );
}